import Glide from '@glidejs/glide';

const ucllGlideDefaults = {
	perView: 1,
	gap:	40, // 2.5rem = 40px
}

function ucllbDestroyGlideSlider( el ){
	if( !el._glideInstance ){
		return;
	}

	el._glideInstance.destroy();
	delete el._glideInstance;
	delete el.dataset.glideMounted;

	ucllbResetGlideTabindex( el );
}

function ucllbGetInt( value, fallback ){
	const parsed = parseInt( value, 10 );
	return Number.isFinite( parsed ) ? parsed : fallback
}

function ucllbGetOptions( el ){
	let perView			= ucllbGetInt( el.dataset.glidePerView, ucllGlideDefaults.perView );
	let breakpointsPx	= window.ucllbGetBreakpointsPx();

	return {
		// Set config
		type:		'slider',
		keyboard:	false,
		perTouch:	1,

		breakpoints: {
			[( breakpointsPx.lg || 1000 ) - 1]: {
				perView: Math.min( perView, 2 )
			},
			[( breakpointsPx.md || 782 ) - 1]: {
				perView: 1
			}
		},

		// Block-customisable config
		perView:	perView,
		gap:		ucllbGetInt( el.dataset.glideGap, ucllGlideDefaults.gap ),
	}
}

const ucllbGlideSetSliderMode = el => ucllbSwitchGlideMode( el );
const ucllbGlideSetGridMode = el => ucllbSwitchGlideMode( el, false );

function ucllbInitGlideSliders( root = document ){
	root.querySelectorAll( '.ucllb-glide' ).forEach( el => {
		if( ucllbIsResponsiveGlideSlider( el ) ){
			ucllbInitResponsiveGlideSlider( el );
			return;
		}

		ucllbMountGlideSlider( el );
	});
}

function ucllbInitResponsiveGlideSlider( el ){
	if( el._glideResponsiveInitialised ){
		ucllbSyncResponsiveGlideSlider( el );
		return;
	}

	const breakpointsPx = window.ucllbGetBreakpointsPx();
	let crossoverBreakpointPx = breakpointsPx[el.dataset.crossoverBreakpoint] || null;

	if( !crossoverBreakpointPx ){
		ucllbMountGlideSlider( el );
		return;
	}

	const mediaQuery = window.matchMedia( `(max-width: ${ crossoverBreakpointPx - 1 }px)` );
	const onChange = () => ucllbSyncResponsiveGlideSlider( el );

	el._glideMediaQuery = mediaQuery;
	el._glideMediaQueryHandler = onChange;
	el._glideResponsiveInitialised = true;

	mediaQuery.addEventListener( 'change', onChange );
	onChange();
}

function ucllbIsResponsiveGlideSlider( el ){
	return (
		'true' === el.dataset.enableGrid
		&& 'string' === typeof el.dataset.crossoverBreakpoint
		&& '' != el.dataset.crossoverBreakpoint
	);
}

function ucllbMountGlideSlider( el ){
	if( el._glideInstance ){
		ucllbGlideSetSliderMode( el );
		ucllbUpdateGlideTabindex( el._glideInstance );
		return el._glideInstance;
	}

	const glide = new Glide( el, ucllbGetOptions( el ) );
	glide.on( ['mount.after', 'run.after', 'resize', 'update'], () => ucllbUpdateGlideTabindex( glide ) );
	glide.mount();

	el._glideInstance = glide;
	el.dataset.glideMounted = 'true';
	ucllbGlideSetSliderMode( el );

	return glide;
}

function ucllbResetGlideTabindex( el ){
	el.querySelectorAll( '.glide__slide' ).forEach( slide => {
		slide.removeAttribute( 'inert' );
		slide.removeAttribute( 'aria-hidden' );
	});
}

function ucllbSwitchGlideMode( el, slider = true ){
	el.dataset.mode = slider ? 'slider' : 'grid';
}

function ucllbSyncResponsiveGlideSlider( el ){
	if( !el._glideMediaQuery ){
		return;
	}

	if( el._glideMediaQuery.matches ){
		ucllbMountGlideSlider( el );
		return;
	}

	ucllbDestroyGlideSlider( el );
	ucllbGlideSetGridMode( el );
}

function ucllbUpdateGlideTabindex( glide ){
	const root = ( glide.selector instanceof HTMLElement ) ? glide.selector : document.querySelector( glide.selector );

	if( !root ){
		console.warn( 'Glide tabindex - no root' );
		return;
	}

	const slides	= [...root.querySelectorAll( '.glide__slide:not( .glide__slide--clone )' )];
	const clones	= root.querySelectorAll( '.glide__slide--clone' );
	const perView	= Number( glide.settings.perView || 1 );
	const start		= glide.index;
	const end		= start + perView;

	clones.forEach( slide => {
		slide.setAttribute( 'inert', '' );
		slide.setAttribute( 'aria-hidden', 'true' );
	});

	slides.forEach( ( slide, index ) => {
		const isVisible = ( index >= start ) && ( index < end );

		slide.toggleAttribute( 'inert', !isVisible );
		slide.setAttribute( 'aria-hidden', isVisible ? 'false' : 'true' );
	});
}

document.addEventListener( 'DOMContentLoaded', () => ucllbInitGlideSliders() );

if( window.wp?.domReady ){
	window.wp.domReady( () => ucllbInitGlideSliders() );
}

window.ucllbInitGlideSliders = ucllbInitGlideSliders;